import React from "react";
import JobPerformanceBody from "./JobPerformanceBody";
import Layout from "../layout/Layout";

const JobPerformance = ({ history }) => {
	return (
		<Layout title="Job Performance" description="Report">
			<JobPerformanceBody />
		</Layout>
	);
};

export default JobPerformance;
